import React, { Component } from 'react';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconTicketTotal from '../../assets/icons/IconTicketTotal';
import { dashboardAverageTime } from '../../util/date';

const COLORS_OVERVIEW = ["#2E90FC", "#1D53A5"];

class TicketOverviewChartCSO extends Component {
    render() {
        return (
            <>
                {/* Overview */}
                <div className="rounded-md shadow-lg relative col-span-5 bg-white h-96">
                    <div className="text-nexcareblue1 p-3">
                        <div className="flex justify-between pt-3">
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={100} />
                                    : <p className="text-xl font-bold">Overview</p>
                            }
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={100} />
                                    : <div className="text-gray-700 text-base font-semibold flex">
                                        <div className="mt-2 mr-3"> <IconTicketTotal /> </div>
                                        <p> Total Tiket </p>
                                    </div>
                            }
                        </div>
                    </div>

                    {
                        this.props.loading
                            ? <div className="px-3"><Skeleton height={175} /></div>
                            : <div>
                                {
                                    this.props.data.length > 0
                                        ? <div className="w-full h-60">
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    data={this.props.data}
                                                    onClick={this.props.handlePopupTicketOverview}
                                                    margin={{
                                                        top: 5,
                                                        bottom: 5,
                                                        left: -20,
                                                        right: 15,
                                                    }}
                                                >
                                                    <CartesianGrid strokeDasharray="1 1" />
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="ticket" fill="#8884d8">
                                                        {this.props.data.map((entry, index) => (
                                                            <Cell id="btnoverview" key={`cell-${index}`} fill={COLORS_OVERVIEW[index % 2]} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                        : <div className="w-full h-60 flex justify-center items-center text-lg font-medium">
                                            <p className="text-darkgrey">Tidak ada data</p>
                                        </div>
                                }
                            </div>
                    }

                    <div className="rounded-b-md bg-blue-200 p-3 w-full absolute bottom-0">
                        <div className="text-nexcareblue1 flex justify-between px-5">
                            <div className="flex justify-between">
                                <div className="font-bold text-xl">
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={50} />
                                            : <div>{this.props.detail.totalClosedTicket ? this.props.detail.totalClosedTicket : '0'}</div>
                                    }
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={50} />
                                            : <div>{this.props.detail.slaResolutionTime ? this.props.detail.slaResolutionTime : '0'}%</div>
                                    }
                                </div>

                                <div className="pl-5 text-lg font-medium">
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={150} />
                                            : <div>Terselesaikan</div>
                                    }
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={150} />
                                            : <div>Resolusi Dalam SLA</div>
                                    }
                                </div>
                            </div>
                            <div className="flex justify-between">
                                <div className="font-bold text-xl">
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={50} />
                                            : <div>{this.props.detail.averageResolutionTime ? dashboardAverageTime(this.props.detail.averageResolutionTime) : '0'}</div>
                                    }
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={50} />
                                            : <div>{this.props.detail.averageResponseTime ? dashboardAverageTime(this.props.detail.averageResponseTime) : '0'}</div>
                                    }
                                </div>
                                <div className="pl-5 text-lg font-medium">
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={150} />
                                            : <div>Rata-Rata Waktu Penyelesaian</div>
                                    }
                                    {
                                        this.props.loading
                                            ? <Skeleton height={20} width={150} />
                                            : <div>Rata-Rata Waktu Merespon</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default TicketOverviewChartCSO;